
import {
  //rea
  getCurrentCVResultsOfReagentManufacturer,
  createCVResultsOfReagentManufacturer,
  getCurrentCVResultsOfReagentApplication,
  createCVResultsOfReagentApplication,
  getCurrentCVResultsOfReagentTypeAndAddInfoAndValue,
  createCVResultsOfReagentTypeAndAddInfoAndValue,
  // exp
  getCurrentCVResultsOfOmicsTypeAndExpType,
  getCurrentCVResultsOfInstrumentManufacturer,
  createCVResultsOfInstrumentManufacturer,
  getCurrentCVResultsOfDigestEnzyme,
  getCurrentCVResultsOfDigestProtocol,
  getCurrentCVResultsOfSeparationMethod,
  createCVResultsOfDigestProtocol,
  createCVResultsOfDigestEnzyme,
  createCVResultsOfExpType,
  createCVResultsOfOmicsType,

  // smaple
  getCurrentCVResultsOfSampleLocationTypeAndTemperature,
  getCurrentCVResultsOfSampleGenoType,
  getCurrentCVResultsOfSampleTreatmentTypeAndMethod,
  getCurrentCVResultsOfSampleTissueStatus,
  getCurrentCVResultsOfSampleCellTypeAndName,
  getCurrentCVResultsOfSampleMicroorganismTypeAndName,
  getCurrentCVResultsOfRootAndTaxonSpeciesAndTaxonStrain,
  getCurrentCVResultsOfRootAndSampleOrganelle,
  getCurrentCVResultsOfRootAndSampleSystemAndOrganAndTissue,
  createCVResultsOfRootAndSampleOrganelle,
  createCVResultsOfRootAndTaxonSpeciesAndTaxonStrain,
  createCVResultsOfSampleGenoType,
  createCVResultsOfSampleLocationTypeAndTemperature,
  createCVResultsOfSampleTreatmentTypeAndMethod,
  createCVResultsOfSeparationMethod,
  createCVResultsOfSampleMicroorganismTypeAndName,
  createCVResultsOfSampleTissueStatus,
  createCVResultsOfSampleCellTypeAndName,
  createCVResultsOfRootAndSampleSystemAndOrganAndTissue,
  // common
  getCurrentCVResultsOfCommonUnitTypeAndUnit,
  createCVResultsOfCommonUnitTypeAndUnit,
  // exp ins
  getCurrentCVResultsOfAnalyzer,
  getCurrentCVResultsOfInstrumentAnalyzerTolerance,
  getCurrentCVResultsOfInstrumentManufacturerAndInstrument,
  createCVResultsOfTolerance,
  createCVResultsOfInstrumentManufacturerAndInstrument,
  createCVResultsOfAnalyzer
} from '../../api/cv'

const cv = {
  state: {
  },
  mutations: {
  },
  actions: {
    getCurrentCVResultsOfReagentManufacturer ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfReagentManufacturer(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfReagentManufacturer ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfReagentManufacturer(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfReagentApplication ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfReagentApplication(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfReagentApplication ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfReagentApplication(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfReagentTypeAndAddInfoAndValue ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfReagentTypeAndAddInfoAndValue(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfOmicsTypeAndExpType ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfOmicsTypeAndExpType(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfExpType ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfExpType(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfOmicsType ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfOmicsType(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfInstrumentManufacturer ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfInstrumentManufacturer(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfDigestProtocol ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfDigestProtocol(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfDigestProtocol ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfDigestProtocol(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfDigestEnzyme ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfDigestEnzyme(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfDigestEnzyme ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfDigestEnzyme(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfInstrumentManufacturer ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfInstrumentManufacturer(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfSampleLocationTypeAndTemperature ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfSampleLocationTypeAndTemperature(params).then((res) => {
          console.log(res)
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfSampleGenoType ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfSampleGenoType(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfSeparationMethod ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfSeparationMethod(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfSampleTreatmentTypeAndMethod ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfSampleTreatmentTypeAndMethod(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfSampleTissueStatus ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfSampleTissueStatus(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfSampleCellTypeAndName ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfSampleCellTypeAndName(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfSampleMicroorganismTypeAndName ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfSampleMicroorganismTypeAndName(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfRootAndTaxonSpeciesAndTaxonStrain ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfRootAndTaxonSpeciesAndTaxonStrain(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfRootAndSampleOrganelle ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfRootAndSampleOrganelle(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfRootAndSampleSystemAndOrganAndTissue ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfRootAndSampleSystemAndOrganAndTissue(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfCommonUnitTypeAndUnit ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfCommonUnitTypeAndUnit(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfCommonUnitTypeAndUnit ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfCommonUnitTypeAndUnit(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfReagentTypeAndAddInfoAndValue ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfReagentTypeAndAddInfoAndValue(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfRootAndSampleOrganelle ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfRootAndSampleOrganelle(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfRootAndTaxonSpeciesAndTaxonStrain ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfRootAndTaxonSpeciesAndTaxonStrain(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfSampleGenoType ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfSampleGenoType(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfSampleLocationTypeAndTemperature ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfSampleLocationTypeAndTemperature(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfSampleTreatmentTypeAndMethod ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfSampleTreatmentTypeAndMethod(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfSeparationMethod ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfSeparationMethod(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfSampleMicroorganismTypeAndName ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfSampleMicroorganismTypeAndName(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfSampleTissueStatus ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfSampleTissueStatus(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfSampleCellTypeAndName ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfSampleCellTypeAndName(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfAnalyzer ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfAnalyzer(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfInstrumentAnalyzerTolerance ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfInstrumentAnalyzerTolerance(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCurrentCVResultsOfInstrumentManufacturerAndInstrument ({commit}, params) {
      return new Promise((resolve, reject) => {
        getCurrentCVResultsOfInstrumentManufacturerAndInstrument(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfTolerance ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfTolerance(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfInstrumentManufacturerAndInstrument ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfInstrumentManufacturerAndInstrument(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfAnalyzer ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfAnalyzer(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    createCVResultsOfRootAndSampleSystemAndOrganAndTissue ({commit}, params) {
      return new Promise((resolve, reject) => {
        createCVResultsOfRootAndSampleSystemAndOrganAndTissue(params).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    }
  }
}
export default cv



// WEBPACK FOOTER //
// ./src/store/modules/cv.js